import { Alert, Snackbar, Stack } from '@mui/material'
import { useSnackbarStore } from '../store/snackbarStore'

export function SnackbarHost() {
  const items = useSnackbarStore((s) => s.items)
  const dismiss = useSnackbarStore((s) => s.dismiss)

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        top: 24,
        right: 24,
        zIndex: (t) => t.zIndex.snackbar,
        pointerEvents: 'none',
      }}
    >
      {items.map((item) => (
        <Snackbar
          key={item.id}
          open
          autoHideDuration={4000}
          onClose={() => dismiss(item.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{ position: 'static', transform: 'none !important', pointerEvents: 'auto' }}
        >
          <Alert
            severity={item.severity}
            variant="filled"
            onClose={() => dismiss(item.id)}
            sx={{ borderRadius: 2, minWidth: 320 }}
          >
            {item.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  )
}
